/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react'
import PropTypes from 'prop-types'
// TypeScript incorrectly things `useQuery` doesn't exist. This shuts up TS.
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { useQuery } from 'react-apollo'
import get from 'lodash/get'
import ProductsGallery from '../../pages/products/products-gallery'
import query from './query.graphql'

// eg;
// "MKP.PVG:1ed4b513-8ce0-4ae4-8356-3033bdadc383/2001"
// "1ed4b513-8ce0-4ae4-8356-3033bdadc383/2001"
// "MKP.PVG:1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "1ed4b513-8ce0-4ae4-8356-3033bdadc383"
const marketplaceProductIdRegex = /^(?:(.+):)?([-0-9a-zA-Z]+)(?:\/(\d+))?$/

const parseMarketplaceProductId = (
  str: string
): { type: string; id: string; shopId: number } => {
  // prettier-ignore
  const [
    // Skip the full string match
    ,
    type,
    id,
    shopId,
  ] = marketplaceProductIdRegex.exec(str) || []

  return { type, id, shopId: Number(shopId) }
}

// eg;
// "2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383?"
// "/2001/1ed4b513-8ce0-4ae4-8356-3033bdadc383?foo=bar"
const urlProductIdRegex = /^\/?(\d+)\/([-0-9a-zA-Z]+)\/?(\?.*)?$/

const parseUrlProductId = (str: string): { id: string; shop: number } => {
  // prettier-ignore
  const [
    // Skip the full string match
    ,
    shop,
    id,
  ] = urlProductIdRegex.exec(str) || []

  return { id, shop: Number(shop) }
}

export const ProductsInMarkdown = ({ ids = '' }: { ids?: string }) => {
  const { loading, error, data } = useQuery(query, {
    errorPolicy: 'ignore',
    context: { version: 2 },
    variables: {
      ids: ids
        .split(',')
        .map(parseUrlProductId)
        .filter(({ id, shop }) => id && shop),
    },
  })

  if (loading) {
    // TODO: Loading spinner / skeleton?
    return null
  }

  if (error) {
    // eslint-disable-next-line no-console
    console.error(error)
    return null
  }

  const { products = [] } = data || {}

  return (
    <ProductsGallery
      products={products
        // TODO: FIXME: When this is resolved:
        // https://scentregroup.slack.com/archives/C01CU5XJAQ1/p1608602167033600?thread_ts=1608601398.029900&cid=C01CU5XJAQ1
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .filter(product => product.variants && product.variants.length)
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        .map(product => ({
          images: product.variants[0].images.map(
            ({ url }: { url: string }) => url
          ),
          name: product.title,
          price: product.variants[0].price,
          objectId: product.id,
          retailer: {
            name: product.shop.name,
            retailerCode: get(product.shop, 'retailer.sys.id', '<unknown>'),
          },
        }))}
      withPagination={false}
      createProductLink={product => {
        const { id, shopId } = parseMarketplaceProductId(product.objectId)
        return `/shop/product/${shopId}/${id}`
      }}
    />
  )
}

ProductsInMarkdown.propTypes = {
  ids: PropTypes.arrayOf(PropTypes.string),
}
